import React from 'react';
import '../Details.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import { useEffect, useState,useRef } from 'react';
import MenuManager from './MenuManager';
import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
function Menu() {

const pageTitle = "Menu"
const url = `https://wazzzazroom.tablemate.net:/tablemate//endpoints/tables/fetchTables.php`;


const location = useLocation();
const {categoryID, chartID } = useParams(); // assuming your route has :categoryID/:chartID
console.log("Page Route: dcid:" + categoryID + " /  chid:"+chartID)
const [content_data, setData] = useState(null);

  return (
    <div className="details-container-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />
      <div className="menu-page">
        <MenuManager />
      </div>
    </div>
  );
}

export default Menu;
